import { RouteRecordRaw } from "vue-router";
import { ROLES_AND_PERMISSION_ON_ROUTES } from "@/core/configs/rolesAndPermissionsMappingOnRoutes";

const routes: Array<RouteRecordRaw> = [
  {
    path: "",
    name: "soa",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.SOA.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.SOA.PERMISSIONS,
    },
    component: () => import("@/modules/SOA/views/SOA.vue"),
  },
];

export default routes;
